import type { Entity } from '@forto-dev/insights'
import { Box, useTheme } from '@freighthub/silhouette-core'
import { ActivityFeedV2 } from 'features/ActivityFeedV2'
import { ShipmentInterface } from 'features/ShipmentDetails'
import { FC } from 'react'
import { useAuth } from 'service/useAuth'

type ActivityFeedRootProps = {
  shipment?: ShipmentInterface
  // eslint-disable-next-line react/no-unused-prop-types
  userId?: string
  isForShipment: boolean
}

export const ActivityFeedRoot: FC<ActivityFeedRootProps> = (props) => {
  const theme = useTheme()
  const {
    state: { customer },
  } = useAuth()

  if (props.shipment) {
    const entities = [{ id: props.shipment._id, type: 'shipment' as Entity['type'] }]
    if (props.shipment.booking_id) {
      entities.push({ id: props.shipment.booking_id, type: 'booking' })
    }

    return (
      <Box bgcolor={theme.palette.background.paper} pt={theme.spacing(4.25)} data-e2e-id="shipment-activityfeed">
        <ActivityFeedV2 entities={entities} />
      </Box>
    )
  }
  if (props.isForShipment === false && customer?._id) {
    return (
      <Box bgcolor={theme.palette.background.paper} pt={theme.spacing(4.25)} data-e2e-id="shipment-activityfeed">
        <ActivityFeedV2
          entities={[
            {
              id: customer._id,
              type: 'customer',
            },
          ]}
        />
      </Box>
    )
  }
}
